<template>
  <div>
    <div v-if="files.length" class="label-absolute">{{ label }}</div>
    <div @click="$refs.inputAvatar.click()" class="fake-input-avatar mt-4">
      <div class="ml-2">
        {{ files.length ? files[0].name : label }}
      </div>
      <input
        class="form-control"
        ref="inputAvatar"
        type="file"
        :label="label"
        :accept="type === 'images' ? 'image/*' : 'file/*'"
        @change="handleChangeFile($event)"
        hidden
      />
    </div>
    <div wrap align-center v-if="type === 'images'">
      <div
        v-for="row_fi in offer.images"
        :key="row_fi.fi_id"
        style="padding:2px;"
      >
        <v-img
          :src="
            `${$config.server_url}/api/1.0/images/${row_fi.fi_id}/75/75?token=${$store.state.accesstoken}`
          "
          height="75px"
          width="75px"
        ></v-img>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mselect",
  components: {},
  props: {
    label: String,
    type: String,
    offer: Object
  },
  data() {
    return {
      files: []
    };
  },
  mounted() {},
  methods: {
    handleChangeFile(e) {
      let files = e.target.files;
      if (!files.length) return;
      this.files = e.target.files;
      this.$emit("inputfile", files, this.type);
    },
    reset() {
      this.files = [];
    }
  }
};
</script>
<style scoped lang="scss">
.fake-input-avatar {
  position: relative;
  border-bottom: solid 1px gray;
  height: 30px;
  overflow: hidden;
}
.label-absolute {
  position: absolute;
  top: 5px;
  left: O;
  color: gray;
  font-size: 12px;
}
</style>
